import { useI18n, LANGUAGES } from "../../i18n/I18nContext";
import { Globe } from "lucide-react";
import { useState, useRef, useEffect } from "react";

export function LanguageSwitcher({ variant = "light" }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const isDark = variant === "dark";

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        data-testid="language-switcher"
        className={`flex items-center gap-2 px-2.5 py-1.5 rounded-md transition ${
          isDark ? "text-white hover:bg-white/10" : "text-[#0F4C3A] hover:bg-[#F8FAF9]"
        }`}
      >
        <Globe className="w-4 h-4" />
        <span className="text-sm font-medium">{current.label}</span>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white border border-[#E2E8E4] rounded-md shadow-lg overflow-hidden min-w-[140px] z-50">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm transition flex items-center justify-between ${
                lang === l.code ? "bg-[#F0FDF4] text-[#0F4C3A] font-medium" : "text-[#475569] hover:bg-[#F8FAF9]"
              }`}
            >
              <span>{l.name}</span>
              <span className="text-xs tracking-wider text-[#94A3B8]">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
